import * as React from "react";
import { useQuery } from "@apollo/client";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Spin } from "antd";
import { meQuery } from "../../Me";
import { MeQueryQuery } from "../../../schemaTypes";

export const AuthRoute: React.FC = () => {
  const { data, loading, error } = useQuery<MeQueryQuery>(meQuery);
  const location = useLocation();
  const next = location.pathname + location.search + location.hash;

  if (loading) return <Spin fullscreen style={{color:"black"}} tip="Loading..." size="large" />;
  if (error) return <Navigate to="/login" replace state={{ next }} />;

  if (!data) {
    return null;
  }

  if (!data?.me || error) {
    return <Navigate to="/login" replace state={{ next }} />;
  }

  if (data.me.isVerified === false) {
    return <Navigate to="/resend-email" replace />;
  }

  if (
    ['Account Verified'].includes(data.me.onboarding?.status || "")
  ) {
    return <Navigate to="/finish-signup" replace />;
  }

  if (data.me.suspended === true) {
    return <Navigate to="/account-suspended" replace />;
  }

  return <Outlet />;
};